export function onKeyPress(event) {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault()
        const inputs = Array.prototype.slice.call(document.querySelectorAll("input"))
        const index = (inputs.indexOf(document.activeElement) + 1) % inputs.length
        const input = inputs[index]
        input.focus()
        input.select()
    }
};